import { packingSlipSchema } from "@redotech/redo-model/packing-slips/packing-slip-definition";

export const updatePackingSlipTemplate = {
  input: packingSlipSchema,
  output: packingSlipSchema,
};
